import { render } from "./FilterATSalesmanKabupatenByToko.vue?vue&type=template&id=5a5d2822"
import script from "./FilterATSalesmanKabupatenByToko.vue?vue&type=script&lang=js"
export * from "./FilterATSalesmanKabupatenByToko.vue?vue&type=script&lang=js"
script.render = render

export default script